import axios from "axios";
import { useState } from "react";
import { FileDown, Loader2, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CollectionFilters = ({ filters, onChange, payers, payees, accounts, month, count, loading }) => {
  const { can } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const download = async () => {
    setBusy(true); setError("");
    try {
      const params = Object.fromEntries(Object.entries({ month, ...filters }).filter(([, value]) => value));
      const response = await axios.get(`${API}/collections/export.xlsx`, { params, responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url; link.download = `tahsilatlar-${month || "tum-zamanlar"}.xlsx`;
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch { setError("Excel indirilemedi. Lütfen tekrar deneyin."); }
    finally { setBusy(false); }
  };
  return (
    <div className="collection-filters" data-testid="collection-filters">
      <div className="collection-filter-fields">
        {[{ key: "payer", label: "Ödeyen", options: payers }, { key: "payee", label: "Ödenen", options: payees },
          { key: "account", label: "Hesap", options: accounts }].map(({ key, label, options }) => (
          <div className="field" key={key}>
            <label htmlFor={`collection-filter-${key}`}>{label}</label>
            <select id={`collection-filter-${key}`} data-testid={`collection-filter-${key}`} value={filters[key]} onChange={e => onChange({ ...filters, [key]: e.target.value })}>
              <option value="">Tümü</option>
              <option value="__none__">Belirtilmedi</option>
              {[...new Set([...options, filters[key]])].filter(v => v && v !== "__none__").map(option => <option key={option} value={option}>{option}</option>)}
            </select>
          </div>
        ))}
      </div>
      <div className="collection-filter-actions">
        <span className="hint" data-testid="collection-filter-count" aria-live="polite">{loading ? "Yükleniyor…" : `${count} tahsilat`}</span>
        <button type="button" className="outline-btn" disabled={!Object.values(filters).some(Boolean)} data-testid="collection-clear-filters" onClick={() => onChange({ payer: "", payee: "", account: "" })}><X size={15}/> Temizle</button>
        {can("reports") && <button type="button" className="outline-btn" disabled={busy || loading || !count} data-testid="collections-export-excel" onClick={download}>
          {busy ? <Loader2 size={16} className="spin"/> : <FileDown size={16}/>} {busy ? "Hazırlanıyor…" : "Excel indir"}
        </button>}
      </div>
      {error && <p role="alert" className="notice error" data-testid="collections-export-error">{error}</p>}
    </div>
  );
};